// @flow

import { getCloudMigrationInfo } from '@atlassian/mpac-api-client';
import { useFeatureFlags } from '@atlassian/mpac-ui';
import { hooks, log } from '@atlassian/mpac-utils';

import type { CloudMigration } from '@atlassian/mpac-api-client';
import type { AppListingCloudMigration } from '@atlassian/mpac-types';

const useCloudMigrationInfo = (mpacBaseUrl: string, appKey: string): AppListingCloudMigration => {
  const { showCloudMigrationAppListing } = useFeatureFlags();
  if (!showCloudMigrationAppListing) {
    return {
      appKey,
      alternateCloudAppKey: null,
      featureDifferenceDocumentation: null,
      migrationDocumentation: null,
    };
  }
  const {
    result = null,
    error = null,
  }: // eslint-disable-next-line flowtype/no-weak-types
  { result: ?CloudMigration, error: ?any } = hooks.usePromise(() =>
    getCloudMigrationInfo(mpacBaseUrl, appKey)
  );

  if (error) {
    log.error(
      'Cloud migration status check',
      `Failed to retrieve cloud migration status for ${appKey}`,
      error
    );
  }

  return {
    appKey,
    alternateCloudAppKey: appKey === result?.cloudAddonKey ? null : result?.cloudAddonKey,
    featureDifferenceDocumentation: result?.featureDifferenceDocumentation,
    migrationDocumentation: result?.migrationDocumentation,
  };
};

export default useCloudMigrationInfo;
